<div class="container-fluid h-100">
  <div class="row h-100">
    <as-split direction="horizontal" [gutterSize]="20">
      <as-split-area [size]="25" [order]="1">
        <div class="ml-4 flex-column h-100">
          <div class="d-flex flex-column h-100">
            <fieldset>
              <div class="d-flex align-items-center px-2">
                <div class="mr-2">
                  <button
                    (click)="loadItems()"
                    [ngClass]="{
                      'btn-success': isLoading,
                      'btn-light': !isLoading
                    }"
                    class="btn btn-sm"
                  >
                    <i
                      [ngClass]="{ 'la-spin': isLoading }"
                      class="la la-refresh"
                    ></i>
                  </button>
                </div>
                <div class="mr-2" style="float: left">
                  <button
                    (click)="showAddShareModelModal()"
                    [disabled]="isLoading || auth.isViewer('fastsp')"
                    class="btn btn-success btn-sm"
                  >
                    <i class="la la-plus"></i>
                  </button>
                </div>
                <div
                  [isDisabled]="
                    selectedSpareModelNodes.length === 0 || isLoading
                  "
                  class="btn-group mr-1"
                  dropdown
                  style="float: left"
                >
                  <button
                    class="dropdown-toggle btn btn-sm btn-primary"
                    dropdownToggle
                    type="button"
                  >
                    <ng-container *ngIf="selectedSpareModelNodes.length > 0"
                      >{{ "navigations.with" | translate }}
                      <strong>{{ selectedSpareModelNodes.length }}</strong>
                      {{ "navigations.selected" | translate }}
                    </ng-container>
                    <ng-container
                      *ngIf="selectedSpareModelNodes.length === 0"
                      >{{
                        "navigations.no_selection" | translate
                      }}</ng-container
                    >
                    <span class="caret"></span>
                  </button>
                  <ul *dropdownMenu class="dropdown-menu">
                    <li
                      (click)="duplicateModels()"
                      class="btn btn-sm dropdown-item"
                      *ngIf="!auth.isViewer('fastsp')"
                    >
                      <i class="la la-fw la-clone"></i>
                      {{ "navigations.clone" | translate }}
                    </li>
                    <li
                      (click)="shareModelsGrid?.export('xlsx')"
                      class="btn btn-sm dropdown-item"
                    >
                      <i class="la la-fw la-file-excel"></i> XLSX
                    </li>
                    <li
                      (click)="shareModelsGrid?.export('csv')"
                      class="btn btn-sm dropdown-item"
                    >
                      <i class="la la-fw la-file-csv"></i> CSV
                    </li>
                    <li
                      class="divider dropdown-divider"
                      *ngIf="!auth.isViewer('fastsp')"
                    ></li>
                    <li role="menuitem" *ngIf="!auth.isViewer('fastsp')">
                      <a
                        class="dropdown-item btn btn-sm btn-danger"
                        (click)="showMassDeleteConfirm()"
                      >
                        <i class="la la-fw la-trash"></i>
                        {{ "navigations.delete" | translate }}
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="mr-2" style="float: left">
                  <button
                    [disabled]="isLoading || auth.isViewer('fastsp')"
                    (click)="showImportModal()"
                    class="btn btn-sm btn-primary"
                  >
                    <i class="la la-fw la-file-csv"></i>
                    {{ "navigations.model.import_models" | translate }}
                  </button>
                </div>
              </div>
            </fieldset>
            <div class="d-flex h-100 w-100 flex-grow-1 pt-2 ag-grid-container">
              <app-grid
                (filterChanged)="onFilterChanged($event)"
                (rowDoubleClicked)="
                  auth.isViewer('fastsp') ? null : onRowClicked($event)
                "
                (selectionChanged)="onSelectionChanged($event)"
                [gridOptions]="gridOptions"
                [rowData]="items"
                class="ag-theme-alpine"
                style="width: 100%; height: 100%"
              >
              </app-grid>
            </div>
          </div>
        </div>
      </as-split-area>
      <as-split-area [size]="75" [order]="2">
        <div class="mr-4 h-100">
          <app-spares
            class="flex-column"
            [sizeColumnsToFit]="sizeColumnsToFit"
            (resetModelsGrid)="resetModelsGrid()"
            [selectedSpareModelNodes]="selectedSpareModelNodes"
          ></app-spares>
        </div>
      </as-split-area>
    </as-split>
  </div>
</div>
